import {
  Callout,
  Loading,
  Panel,
  useLoad,
} from '@affdice/portal-kit';
import {
  PlatformApi,
} from '../../../client.ts';
import { t } from '../../../messages.ts';
import { Failure, OperatorFigures } from '../../shared.tsx';

/** Same click-to-load shape as `OperatorAffiliatesPanel` — §3.9c logs per access. */
export function OperatorAnalyticsPanel({ api, operatorId, shown, onShow }: {
  api: PlatformApi;
  operatorId: string;
  shown: boolean;
  onShow: () => void;
}) {
  // See OperatorAffiliatesPanel — the guard has to be in the loader.
  const loaded = useLoad(
    () => (shown ? api.operatorAnalytics(operatorId) : Promise.resolve(null)),
    [operatorId, shown],
  );

  if (!shown) {
    return (
      <Panel title={t('ops.dash.title')}>
        <Callout>
          {t('ops.dash.note')}
        </Callout>
        <div className="form-actions">
          <button className="primary" onClick={onShow}>{t('ops.dash.view')}</button>
        </div>
      </Panel>
    );
  }

  if (loaded.state === 'error') return <Panel title={t('ops.dash.title')}><Failure error={loaded.error} /></Panel>;
  if (loaded.state === 'loading' || !loaded.value) {
    return <Panel title={t('ops.dash.title')}><Loading rows={2} /></Panel>;
  }

  return (
    <Panel title={t('ops.dash.titleFor', { operator: loaded.value.operator })}>
      {loaded.value.unavailable_because ? <Callout tone="caution">{loaded.value.unavailable_because}</Callout> : null}
      {loaded.value.is_provisional ? (
        <Callout tone="caution">{loaded.value.provisional_because ?? t('ops.dash.provisional')}</Callout>
      ) : null}
      <OperatorFigures data={loaded.value.data} />
      <Callout>{t('ops.dash.asOf', { date: loaded.value.data_as_of })}</Callout>
    </Panel>
  );
}
